import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { CalculationService } from "../../../services/CalculationService";
import {
  CalculationResponseInterface,
  CalculationRequestInterface,
} from "../../../entities/Calculation";
import {
  CustomErrorInterface,
  ERROR_REASON_CODE,
} from "../../../entities/Common";
import { createCustomError } from "../../../utils/createCustomError";
import { calculateMixCondimentsProperties } from "../utils/calculateMixCondimentProperties";

export const fetchCalculatedPricesAndVolume = createAsyncThunk<
  CalculationResponseInterface,
  CalculationRequestInterface,
  { rejectValue: AxiosError | CustomErrorInterface }
>(
  "calculation/getCalculatedPricesAndVolume",
  async (data: CalculationRequestInterface, { rejectWithValue }) => {
    try {
      const { condiments, mixtureOption, selectedWeight, ...rest } = data;
      const condimentsWithCalculatedProperties =
        calculateMixCondimentsProperties(condiments, mixtureOption);

      const result = await CalculationService.getCalculatedPricesAndVolume({
        condiments: condimentsWithCalculatedProperties,
        selectedWeight: selectedWeight || 1,
        mixtureOption,
        ...rest,
      });
      const { volume } = result;

      if (volume.minVolumeOfMix > volume.maxVolumeOfMix) {
        return rejectWithValue(
          createCustomError({
            reasonCode: ERROR_REASON_CODE.INCOMPATIBLE_SPICE_COMBINATION,
          }),
        );
      }

      return result;
    } catch (e: any) {
      return rejectWithValue(e.message as AxiosError);
    }
  },
);
